import {Component} from "@angular/core";
import {Router, NavigationEnd, ActivatedRoute} from "@angular/router";
declare let ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.urlAfterRedirects;
        if (url.indexOf("/dashboard/vehicles/detail/") != -1) {
          url = "/dashboard/vehicles/detail/";
        } else if (url.indexOf("/dashboard/routes/detail/") != -1) {
          url = "/dashboard/routes/detail/";
        }
        ga('set', 'page', url);
        ga('send', 'pageview');
      }
    });
  }
}
